export default __webpack_public_path__ + "static/screenshot-e76c2ecee49bec2f89100c3e963e2db1.png";